import { Component, Inject, OnInit, signal } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogClose,
  MatDialogContent,
} from '@angular/material/dialog';
import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import { dataStore, db } from 'src/app/app.component';
import { valueToDate } from 'src/app/globals';
import { Particularity, RideEdits } from 'src/app/interfaces';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatTooltip } from '@angular/material/tooltip';
import { MatChipListbox, MatChipOption } from '@angular/material/chips';
import { DatePipe } from '@angular/common';

export interface DialogData {
  deletedRide: any;
}
@Component({
  selector: 'app-deleted-ride-information',
  templateUrl: './deleted-ride-information.component.html',
  styleUrls: ['./deleted-ride-information.component.scss'],
  imports: [
    MatDialogTitle,
    CdkDrag,
    CdkDragHandle,
    MatIcon,
    MatIconButton,
    MatDialogClose,
    CdkScrollable,
    MatDialogContent,
    MatTooltip,
    MatChipListbox,
    MatChipOption,
    DatePipe,
  ],
})
export class DeletedRideInformationComponent implements OnInit {
  organisationId = localStorage.getItem('orgId');
  deletedRide = signal<any>(undefined);
  details = signal<boolean>(false);
  users = signal<Array<any>>([]);
  particularities = signal<Particularity[]>(dataStore.selectedOrganisation.particularities);
  allEdits = signal<RideEdits[]>([]);

  valueToDate = valueToDate;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(): void {
    this.deletedRide.set(this.data.deletedRide);
    if (this.deletedRide().rideData.users) {
      Object.keys(this.deletedRide().rideData.users).forEach((key) => {
        this.deletedRide().rideData.users[key].id = key;
      });
      this.users.set(
        Object.values(this.deletedRide().rideData.users).sort((x: any, y: any) => {
          return x.order - y.order;
        }),
      );
    }

    let allEditsData: RideEdits[] = [];
    const allEditsQuery = query(
      collection(
        db,
        `eventLogs/${this.organisationId}/deletedRides/${this.deletedRide().rideData.id}/edits`,
      ),
      orderBy('date', 'desc'),
    );
    getDocs(allEditsQuery).then((docs) => {
      docs.forEach((doc) => {
        const data = doc.data() as RideEdits;
        data['id'] = doc.id;
        allEditsData.push(data);
      });
      this.allEdits.set(allEditsData);
    });
  }
}
